module.exports = __webpack_public_path__ + "images/plp/boat-storage.svg";